"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "locale"
            ]);
        },
        innerBody: function() {
          return this.input.renderBody.toString().replace(new RegExp("function\\s*\\(\\w+\\)\\s*\\{\\s*\\w+.t\\(\""), "").replace(new RegExp("\"\\);?\\s*\\}"), "");
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Locale/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("span", {
      "data-lang": state.locale.language + (state.locale.variant ? "-" + state.locale.variant : ""),
      "class": marko_classValue(input.class),
      style: marko_styleValue("color:inherit;" + input.style)
    }, "0", component);

  out.h(Locale(input.text || ((typeof input.renderBody) == "function" ? component.innerBody() : ""), input.notrack), component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
